import type RetentionPolicyTag from 'owa-service/lib/contract/RetentionPolicyTag';
import { getStore } from '../store/store';

/**
 * Selector for the shared folder policy tags
 */
export default function getSharedFolderPolicyTagList(userIdentity: string): RetentionPolicyTag[] {
    const retentionPolicyTags = getStore().retentionPolicyTags;
    if (userIdentity && retentionPolicyTags.has(userIdentity)) {
        return retentionPolicyTags.get(userIdentity);
    }

    return [];
}
